import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "daster",
  style: {"padding":"0 30px"}
}
const _hoisted_2 = { class: "d-flex flex-stack container-fluid px-0 mb-5" }
const _hoisted_3 = { class: "page-title d-flex flex-row justify-content-center flex-wrap" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left fs-2x" }, null, -1)
const _hoisted_5 = { class: "page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center ms-4 my-0" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "d-flex justify-content-center align-items-end mb-6" }
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  class: "card-header p-0 overflow-auto w-100",
  style: {"height":"192px"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex z-index-1 position-absolute top-0 end-0 p-4" }, null, -1)
const _hoisted_11 = { class: "card-body p-5" }
const _hoisted_12 = { class: "title mb-4 fs-5 text-hover-primary text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_image = _resolveComponent("el-image")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "",
          to: "welcome"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.t('tutorials')), 1)
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTutorials, (evento, index) => {
          return (_openBlock(), _createElementBlock("a", {
            key: index,
            href: `${evento.url}`,
            target: "_blank",
            class: "card mb-8 me-6 shadow text-black text-hover-primary border border-2 border-primary border-hover"
          }, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_el_image, {
                class: "w-100 h-100",
                src: evento?.thumb,
                fit: 'contain'
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h2", _hoisted_12, _toDisplayString(evento?.name), 1)
            ])
          ], 8, _hoisted_8))
        }), 128))
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ])
  ]))
}